import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_change_status_payement",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content position-relative"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "varyingModalLabel"
}, " Action de correction comptable ", -1)
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "info-box" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", { class: "bold" }, "État actuel : ", -1)
const _hoisted_11 = { class: "info-grid" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", { class: "bold" }, "Montant : ", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "info-box" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", { class: "bold" }, "État choisir : ", -1)
const _hoisted_20 = {
  key: 0,
  class: "warning-box"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("b", null, "⚠️ Impact de cette action")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Le statut passera à "),
    /*#__PURE__*/_createElementVNode("b", null, "Payé")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Le montant sera ajouté à la "),
    /*#__PURE__*/_createElementVNode("b", null, "caisse")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Les rapports financiers seront mis à jour")
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "info-box" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Vous êtes sur le point de modifier un paiement déjà validé. ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "warning-box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("b", null, "ℹ️ Impact de la modification")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Le statut sera remis à "),
      /*#__PURE__*/_createElementVNode("b", null, "En attente")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "Le montant sera retiré de la caisse"),
    /*#__PURE__*/_createElementVNode("li", null, "Les rapports financiers seront mis à jour")
  ])
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group mr-b-0em" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_34 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_35 = { class: "form-group mr-b-0em" }
const _hoisted_36 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_37 = { class: "form-group mr-b-0em" }
const _hoisted_38 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_39 = { class: "form-group mr-b-0em" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "form-group mr-b-0em" }
const _hoisted_42 = { class: "col-12 text-right" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mr-2"
}, " Confirmer le paiement ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_element_status_payment = _resolveComponent("element-status-payment")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_price_input = _resolveComponent("price-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.transaction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.isRequestPayment)
              ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_change_status_payement', 'add'))),
                type: "button",
                class: "btn-close",
                "aria-label": "btn-close"
              })
            ]),
            (_ctx.requestPayment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_element_status_payment, {
                          status: _ctx.transaction?.status
                        }, null, 8, ["status"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", null, [
                          _hoisted_12,
                          _createElementVNode("span", null, _toDisplayString(_ctx.transaction?.amount_paid) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                        ]),
                        (_ctx.transaction?.dueDate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("b", _hoisted_14, _toDisplayString(_ctx.i18n.t('tables.payment.accessBlockDate')) + " : ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.transaction?.dueDate)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_15
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_element_status_payment, {
                          status: _ctx.requestPayment?.status
                        }, null, 8, ["status"])
                      ]),
                      (_ctx.requestPayment.status == 'paid')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                        : (_ctx.requestPayment.status == 'scheduled')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("form", {
                    class: "forms-sample",
                    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.payment.status'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestPayment.status,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestPayment.status) = $event)),
                          placeholder: _ctx.i18n.t('tables.payment.status'),
                          arrayOptions: _ctx.payementStatusList,
                          refs: "status",
                          v: _ctx.v$.status
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_date_field, {
                            modelValue: _ctx.requestPayment.paymentDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestPayment.paymentDate) = $event)),
                            label: _ctx.i18n.t('tables.payment.paymentDate'),
                            v: _ctx.v$.paymentDate,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.payment.paymentMethod'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestPayment.paymentMethod,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestPayment.paymentMethod) = $event)),
                          placeholder: _ctx.i18n.t('tables.payment.paymentMethod'),
                          arrayOptions: _ctx.payment_methodsList,
                          refs: "paymentMethod",
                          v: _ctx.v$.paymentMethod
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      (_ctx.requestPayment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createVNode(_component_SingleSelect, {
                              TextLabel: _ctx.i18n.t('tables.payment.bankName'),
                              trackby: `id`,
                              label: `name`,
                              valueProp: `id`,
                              modelValue: _ctx.requestPayment.bankName,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestPayment.bankName) = $event)),
                              placeholder: _ctx.i18n.t('tables.payment.bankName'),
                              arrayOptions: _ctx.bank_namesList,
                              refs: "bankName",
                              v: _ctx.v$.bankName
                            }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPayment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestPayment.chequeName,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestPayment.chequeName) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeName'),
                                v: _ctx.v$.chequeName,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPayment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestPayment.chequeNum,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestPayment.chequeNum) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeNum'),
                                v: _ctx.v$.chequeNum,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPayment.paymentMethod === 'Chèque bancaire' || _ctx.requestPayment.status == 'scheduled')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_date_field, {
                                modelValue: _ctx.requestPayment.dueDate,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestPayment.dueDate) = $event)),
                                label: _ctx.requestPayment.status == 'scheduled' ? _ctx.i18n.t('tables.payment.accessBlockDate') : _ctx.i18n.t('tables.payment.dueDate'),
                                v: _ctx.v$.dueDate,
                                disabled: false,
                                fixedDays: 1,
                                isFixedDays: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_price_input, {
                            modelValue: _ctx.requestPayment.amount_paid,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestPayment.amount_paid) = $event)),
                            label: _ctx.i18n.t('tables.payment.amount_paid'),
                            v: _ctx.v$.amount_paid,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emptyState())),
                          class: "btn btn-cancel"
                        }, _toDisplayString(_ctx.i18n.t('button.clean')), 1)
                      ])
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}